import { Box, Card, Container, Typography, Toolbar, Stack } from '@mui/material'
import React from 'react'
import Footer from '../Components/Footer'
import ContactForm from '../Components/ContactForm'


export default function
    () {
    return (
        <React.Fragment>
            <Box >
                <br />
                <Typography variant='h3' component='h3' sx={{ marginLeft: "auto", marginRight: "auto" }}>
                    Contact Us
                </Typography>
                <br />
                <Container >
                    <Typography variant='body1' align='left'>
                        Ready to collaborate, explore, or innovate? Reach out to us to discover how we can work together to advance the boundaries of technology and knowledge. Whether you're a researcher, student, industry partner, or technology enthusiast, HPC Nexus Lab welcomes you to join us.

                    </Typography>
                    <Toolbar />
                    <Container maxWidth="sm">
                        <ContactForm />
                    </Container>
                    <Typography variant='subtitle2' align='left'>
                        <Stack direction={{ xs: "column", md: "row" }}>
                            <Container>
                                We can be reached by post at:
                                <br />
                                HPC Nexus Laboratory
                                <br />School of Informatics and CyberSecurity
                                <br />Technological University Dublin
                                <br />Blanchardstown Campus
                                <br />Blanchardstown Rd N,
                                <br />Blanchardstown, Dublin
                                <br />D15 YV78
                                <br />Ireland
                                <br />
                            </Container>
                        </Stack>
                    </Typography>
                </Container>
            </Box>
            <Toolbar />
            <Footer />
        </React.Fragment>
    )
}
